import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"
import { LocationHistoryService } from "../../../api/locationHistory"
import type { SuggestedLocation } from "./LocationPickerModal"

type UseSuggestedWarehouseLocationsArgs = {
  isEnabled: boolean
  warehouseId?: string
  productId?: string
}

// useSuggestedWarehouseLocations builds location suggestions for a selected product.
export function useSuggestedWarehouseLocations({
  isEnabled,
  warehouseId,
  productId,
}: UseSuggestedWarehouseLocationsArgs): SuggestedLocation[] {
  const { data: suggestions } = useQuery({
    queryKey: [
      "wms",
      "warehouse",
      "product-location-suggestions",
      warehouseId,
      productId,
    ],
    queryFn: () =>
      LocationHistoryService.getProductLocationSuggestions(
        warehouseId!,
        productId!,
        8,
      ),
    enabled: isEnabled && !!warehouseId && !!productId,
  })

  return useMemo<SuggestedLocation[]>(() => {
    return (suggestions?.items ?? []).map((item) => ({
      code: item.code,
      source: item.source,
      qty: item.qty_on_hand,
      lastSeenAt: item.last_seen_at,
    }))
  }, [suggestions?.items])
}
